module.exports = __webpack_public_path__ + "img/attach-attach.d57bfc61.svg";